import { render, staticRenderFns } from "./footerbox.vue?vue&type=template&id=ee5af822&scoped=true"
import script from "./footerbox.vue?vue&type=script&lang=js"
export * from "./footerbox.vue?vue&type=script&lang=js"
import style0 from "./footerbox.vue?vue&type=style&index=0&id=ee5af822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5af822",
  null
  
)

export default component.exports